export default {
    methods: {
        async doUpload(url, selectedFiles) {
            if (selectedFiles.length > 0) {
                let httpPromiseArr = []

                for (let i = 0; i < selectedFiles.length; i++) {
                    let formData = new FormData()
                    formData.append(
                        'file',
                        selectedFiles[i],
                        selectedFiles[i].name
                    )
                    try {
                        httpPromiseArr.push(
                            this.$http.post(url, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })
                        )
                    } catch (e) {
                        console.error(e)
                    }
                }

                return Promise.all(httpPromiseArr)
                    .then(values => {
                        return values
                    })
                    .catch(error => {
                        console.error('file upload error: ', error)
                    })
            }
        },
    },
}
